<template>
  <div class="slider-input" v-if="!readOnly && internalValue!==undefined">
      <text-with-units v-if="!isRange" type="text" v-model="internalValue" :unit="view.units" :min="minVal" :max="maxVal" :round="step" class="numeric-input"/>
      <text-with-units v-if="isRange" type="text" v-model="internalValue[0]" :unit="view.units" :min="minVal" :max="maxVal" :round="step" class="numeric-input"/>
      <div class="slider-container">
        <vue-slider
          type="range"
          :min="minVal"
          :max="maxVal"
          :interval="step"
          v-model="internalValue"
        />
      </div>
      <text-with-units v-if="isRange" type="text" v-model="internalValue[1]" :unit="view.units" :min="minVal" :max="maxVal" :round="step" class="numeric-input"/>

      <!-- :disabled="readOnly"  -->
  </div>
  <div class="slider-input" v-else>
    <span>{{internalValue}}</span>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'
import TextWithUnits from '@/components/inputs/TextWithUnits'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'InputSliderType',
  mixins: [inputMixin],
  components: {
    VueSlider,
    TextWithUnits
  },
  computed: {
    isRange () {
      return this.view.inputType==='sliderRange'
    }
  }
}
</script>

<style lang="stylus" scoped>
.slider-input
  display flex
  align-items center
  //min-width 240px
  input
    width 70px
  .slider-container
    width 100%
    margin 3px 20px
    min-width: 100px;
  >>> .vue-slider
    cursor pointer
    &:hover
      .vue-slider-dot-handle-focus
        border-color: $radical-red

    .vue-slider-rail
      background-color: $heather
      height: 2px

    .vue-slider-process
      background-color: $radical-red

    .vue-slider-dot-handle
      border-color: rgba($radical-red, 0.75)

      &:hover
        border-color: $radical-red

    .vue-slider-dot-handle-focus
      box-shadow: 0 0 0 5px rgba($radical-red, 0.2)
</style>